// extracted by mini-css-extract-plugin
export default {"layout":"a2phq","layoutContent":"b2phq"};